import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import ScreeningsList from './ScreeningsList/ScreeningsList';
import ScreeningEdit from './ScreeningEdit/ScreeningEdit';
import ScreeningDelete from './ScreeningDelete/ScreeningDelete';
import ScreeningCreate from './ScreeningCreate/ScreeningCreate';

const Screenings = ({ match }) => {
    return (
        <div className="Screenings">
            <ContainerWrapper container="screenings">
                <Route exact path={match.path} component={ScreeningsList} />
                <Route exact path={ `${ match.url }/new` } component={ScreeningCreate} />
                <Route exact path={`${match.url}/programmation/:programmationId?`} component={ScreeningsList} />
                <Route exact path={`${match.url}/edit/:screeningId`} component={ScreeningEdit} />
                <Route exact path={`${match.url}/delete/:screeningId`} component={ScreeningDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Screenings;
